module.exports = __webpack_public_path__ + "media/icons/communities-icon-cb6c0a36.svg";